import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { object, string } from "yup";

import { SendEmailVerification } from "../../../Api/Signin/Signin.Api";
import useLoadingState from "../../../Utils/Hooks/useLodingState";
import { TextInput } from "../../atoms/Input/TextInput";
import { LoadingButtonType } from "../../atoms/LoadingButton/LoadingButton";
import { FormItemsWrap } from "../Wrap/Wrap";

export const UsernameForm = ({ onClick, t, state }) => {
  const navigate = useNavigate();

  const { LoadingState, startLoading, stopLoading } = useLoadingState();
  const { control, handleSubmit, setError } = useForm({
    defaultValues: {
      username: "",
    },
    resolver: yupResolver(
      object({
        username: string()
          .required(t && t("validation:required-field"))
          .matches(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
            t("validation:invalid-email"),
          ),
      }),
    ),
  });

  const onSubmit = async (formData) => {
    try {
      startLoading({ btnName: "username" });
      SendEmailVerification({
        emailAddress: formData.username,
        language: state.lang.code,
      }).then((d) => { 
        //store the user role 
        localStorage.setItem('UserRoleName', d.data?.roleName ?? "");
        if (d.type == 0) {
          onClick("pass", formData.username);
        } else if (d.message === "user-inactive") {
          navigate("/no-access");
        } else if (d.message === "contact-support") {
          setError("username", "");
          onClick("contact-support");
        } else if (d.type === 3) {
          setError("username", { message: t(d.message, { ns: "validation" }) });
        } else {
          setError("username", { message: t(d.message, { ns: "validation" }) });
        }
        stopLoading();
      });
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormItemsWrap gap={"32px"}>
          <TextInput
            size={"medium"}
            isInherit={true}
            required={true}
            control={control}
            placeholder={t("common:placeholder.email")}
            label={t("common:form.enter-email")}
            name={"username"}
          />

          <LoadingButtonType
            loading={LoadingState.visible}
            type="submit"
            variant="primaryBlue"
          >
            {t("common:button.next")}
          </LoadingButtonType>
        </FormItemsWrap>
      </form>
    </div>
  );
};
